import React from 'react';

import SafeImage from '../PinMatchSilentEval/SafeImage';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './LinkCardUpNext.scss';

/** The next few links in this tab, so the reviewer sees what is coming. */
const LinkCardUpNext = () => {
  const { upNext, status } = useLinksToCheckContext();
  if (status !== 'ready' || !upNext.length) return null;

  return (
    <div className='links-to-check-up-next'>
      <span>Up next</span>
      {upNext.map(item => (
        <span key={item.id} className='up-next-item'>
          <span className='up-next-photo'>
            <SafeImage className='ltc-photo-image' source={item.page?.image || item.creatorPin?.image || item.pair?.remove?.image} alt='' placeholderText='' />
          </span>
          {item.domain}
        </span>
      ))}
    </div>
  );
};

export default LinkCardUpNext;
